





































































import {Port} from '@/system/hardware/interfaces';
import {Vue, Component, Prop, Watch} from 'vue-property-decorator';
import enumsModule from '@/store/modules/enumsModule';
import {TypeData} from '@/api/configurate';
import {PModuleType} from '@/enums/configs';
import SimpleDialog from '@/components/SimpleDialog.vue';
import SelectionList from '@/components/controls/selectionList/SelectionList.vue';
import {PModulesModule} from '@/store/modules/entities/pmodules/pmoduleModule';
import {httpClient} from '@/api/baseApi';
import AskConfirmationDialog from '@c/AskConfirmationDialog.vue';
import hardwareModule from '@/store/modules/entities/hardwareModule';

@Component({
  components: {
    SimpleDialog,
    SelectionList,
    AskConfirmationDialog,
  },
})
export default class PModuleLink extends Vue {
  @Prop({required: true})
  port!: Port;

  @Prop({required: true})
  hardwareId!: number;

  @Prop({required: true})
  hardwareType!: number;

  @Prop({required: false})
  hardwareName?: string;

  @Prop({required: false})
  mac?: string;

  @Prop({required: false})
  route!: boolean;

  @Prop({type: String})
  tooltipStr!: string;

  @Prop({type: Boolean, default: false})
  showTooltip!: boolean;

  @Prop({required: false})
  modules!: any[];

  enabledProp = true;

  // Модель диалога выбора типа элемента
  selectItemTypeDialog = false;

  // Модель диалога выбора типа элемента
  selectPModuleDialog = false;

  // идентификатор выбранного типа
  selectedTypeId: any = null;

  // идентификатор выбранного ПМ
  selectedPMGuid: any = null;

  showBindPM = false;

  pmList: PModulesModule[] = [];

  toRebind = false;

  modulesType!: any;

  @Watch('showBindPM')
  async loadPMList() {
    await this.getPmList();
  }

  @Watch('modules', {immediate: true})
  onModulesChanged() {
    this.countPM();
  }

  chechTypeEnabling(type: string, array: any) {
    for (let i = 0; i < array.length; i++) {
      if (type === array[i]) {
        return true;
      }
    }
    return false;
  }

  get itemTypes(): TypeData[] {
    const pmodulesEnum = this.port.modules.map(module => module.type);
    return enumsModule.moduleTypes.map(x => ({
      id: x.value.toString(),
      type: x.value as PModuleType,
      name: x.description.replace('dtcp ', ''),
      enabled: this.chechTypeEnabling(x.url, pmodulesEnum),
    }));
  }

  // текущий выбранный тип
  get selectedType() {
    const findItems = this.itemTypes.filter(x => x.id == this.selectedTypeId);
    if (findItems.length > 0) return findItems[0];
    return null;
  }

  // Действия при выборе типа элемента
  onSelectItemType() {
    const currentModule = enumsModule.moduleTypes.filter(v => v.value === this.selectedType?.type);
    if (this.selectedType)
      this.$router.push({
        name: `CreateSystemModuleFromHardware`,
        params: {
          type: currentModule[0].url,
          hardware: this.hardwareId.toString(),
          hardwareType: this.hardwareType.toString(),
          port: this.port.id.toString(),
          mac: this.mac ? this.mac : '',
          hardwareName: this.hardwareName ? this.hardwareName : '',
          fromHardware: 'true',
          portName: this.port?.name ? this.port?.name : '',
        },
      });
  }

  get askConfirmationDialog() {
    return this.$refs.askConfirmationDialog as any;
  }

  // Действия при выборе типа элемента
  async onSelectPModule() {
    this.toRebind = true;
    let currentElem: any[] = [];
    currentElem = this.pmList.filter((pm: any) => pm.guid == this.selectedPMGuid);
    if (currentElem[0].hw_pm != null) {
      this.askConfirmationDialog.open(
        `Данный программный модуль уже привязан к АМ. Хотите перепривязать его?`,
        'Перепривязать',
      );
    } else {
      // привязываем ПМ к АМ
      await this.linkHM();
    }
  }

  async answer(res: any) {
    if (res) {
      // привязываем ПМ к АМ
      await this.linkHM();
    }
  }

  // привязывание ПМ к АМ
  async linkHM() {
    if (this.hardwareId && this.port) {
      try {
        await hardwareModule.linkHM({
          hw_id: this.hardwareId,
          pm_guid: this.selectedPMGuid,
          port: this.port.id,
        });
        this.$emit('redrawSchema');
      } catch (err) {
        console.log(err);
      }
    }
  }

  onClick() {
    this.$emit('click', this.port);
    if (this.route) {
      this.selectItemTypeDialog = true;
    }
    this.countPM();
  }

  cancel() {
    this.selectedTypeId = null;
  }

  async getPmList() {
    if (!this.modulesType) {
      await httpClient.get(`/module_types/`).then((res: any) => {
        this.modulesType = res.data;
      }); //поднимаем список всеех типов модулей (чтобы подтянуть объекты для дальнейшего поиска ПМ через type модуля)
    }
    const {data} = await httpClient.get<[]>(`modules/`); //загружаем журнал ПМ
    this.pmList = data;
    // если НЕ указан признак "Отображать привязанные ПМ", грузим только НЕпривязанные к АМ программные модули
    if (!this.showBindPM) {
      const list = this.pmList.filter((pm: any) => pm.hw_pm == null);
      this.pmList = list;
    }
    const pmodulesEnum = this.port.modules.map(module => module.type); //типы ПМ для конкретного порта
    const all = this.modulesType;
    let modulesOfAbleTypes = all.filter((pm: any) => pmodulesEnum.includes(pm.url)); // загружаем объекты модулей (именно те, которые доступны для данного порта)
    modulesOfAbleTypes = modulesOfAbleTypes.map((module: any) => module.type); // формируем список типов этих объектов
    const pmListFilteredByType = this.pmList.filter((pm: any) =>
      modulesOfAbleTypes.includes(pm.type),
    ); // фильтруем журнал ПМ (находим те записи, которые доступны согласно доступным типам порта)
    this.pmList = pmListFilteredByType;
  }

  // событиые кнопки Привязать
  async onBindBtnClick() {
    this.$emit('click', this.port);
    if (this.route) {
      this.getPmList();
      this.selectPModuleDialog = true;
    }
    this.countPM();
  }

  async created() {
    await this.getPmList();
    this.countPM();
  }

  // подсчет максимального количества ПМ у портов АМ
  countPM() {
    let maxCountPM = 0;
    this.port.modules.forEach((x: any) => {
      x.count ? (maxCountPM += x.count) : (maxCountPM += 1);
    });

    let countPM = 0;
    //количество уже привязанных ПМ
    if (this.modules) countPM = this.modules.length;

    if (maxCountPM <= countPM) return (this.enabledProp = false);
    return (this.enabledProp = true);
  }
}
